import { render, staticRenderFns } from "./CustomersSalesman.vue?vue&type=template&id=e48dc3b6&"
import script from "./CustomersSalesman.vue?vue&type=script&lang=js&"
export * from "./CustomersSalesman.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSalesman.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports